import { makeStyles, Typography } from "@material-ui/core";
import dayjs from "dayjs";

const useStyles = makeStyles(() => ({
  inheritFontWeight: {
    fontWeight: "inherit",
  },
}));

interface Props {
  expiryDate: string;
}

const ExpiryCell = ({ expiryDate }: Props): JSX.Element => {
  const expiry = dayjs(expiryDate, "YYYY-MM-DD");
  const classes = useStyles();
  const textColor = expiry.isBefore(dayjs()) ? "error" : "initial";
  return (
    <Typography
      variant="body2"
      className={classes.inheritFontWeight}
      color={textColor}
    >
      {expiry.format("MM / YYYY")}
    </Typography>
  );
};

export default ExpiryCell;
